import { forwardRef } from 'react';
import { useFrameInput } from './frameInput.hook';
import { IFrameInput } from './frameInput.models';
import * as S from './frameInput.style';

export const FrameInput = forwardRef<HTMLInputElement, IFrameInput>(
  (
    {
      checked,
      children,
      control = true,
      styled,
      disabled,
      name,
      onChange,
      style,
      type = 'radio',
      variant = 'primary',
      ...rest
    },
    ref
  ) => {
    const { handleChange } = useFrameInput({ name, onChange });

    return (
      <S.Label
        className={checked ? 'checked' : undefined}
        disabled={disabled}
        style={style}
        styled={styled}
        variant={variant}
      >
        <S.Input
          {...rest}
          checked={checked}
          control={control}
          disabled={disabled}
          name={name}
          onChange={handleChange}
          ref={ref}
          type={type}
          variant={variant}
        />
        {children}
      </S.Label>
    );
  }
);

